export default function ContractTaxRisk({ isChecked, handleCheckboxChange, handleNextButtonClick }) {
  const contractText = `美國稅務風險自檢課：美籍身份、海外收入與補報入門
（購買契約書）
請於報名並完成付款前詳閱下列條款。當您完成報名並完成付款，即表示本契約成立，並視為您已詳細閱讀、理解並同意遵守以下條款。

一、本課程性質
「美國稅務風險自檢課：美籍身份、海外收入與補報入門」（以下簡稱「本課程」）係由捷進顧問有限公司（Direct Line Consulting Co.，另稱 Becker Taiwan）（以下簡稱「本公司」）所舉辦之短期專業知識分享與實務訓練課程。
本課程屬專業研習與風險辨識訓練活動，目的在於協助學員理解美國稅務申報義務、海外收入、海外帳戶、投資收入、租金收入、FBAR、FATCA 與補報風險等基礎觀念。
本課程不提供個別法律、稅務、投資或資產規劃建議，亦不取代任何個案專業諮詢。
本課程並非依《短期補習班設立及管理準則》設立或管理之補習班課程，亦非學歷教育或補習教育課程。
學員報名本課程，即表示了解並同意本課程之性質為專業知識分享、實務風險辨識與基礎稅務架構訓練活動。

二、本服務內容
本公司依課程規劃提供以下服務：
● 講師授課
● 課程講義下載
● 課中或課後 Q&A
● 美國稅務基本觀念、申報義務與風險辨識教學
● 常見跨境稅務情境與案例說明
● 課後可依學員個人需求免費轉介稅務顧問
前項課程折抵優惠之實際折抵金額，將依適用課程系列及本公司公告之優惠辦法而定。本公司保留優惠適用資格、折抵金額、適用課程範圍及相關細節之最終解釋權。
本課程可能依課程安排提供課程錄影回放。若課程錄影回放確認開放，其觀看方式、開放期間及使用限制，將依本公司於課前或課後公告為準。除本公司明確公告外，學員不得主張課程必然提供錄影回放或永久觀看權限。

三、課程時間、形式與地點
本課程採單次 3 小時課程形式進行，學員可依本公司公告之報名方式選擇現場面授或線上直播。
課程日期：2026 年 8 月 22 日（星期六）
課程時間：上午 9:00 至中午 12:00
課程時數：單次 3 小時
現場面授地點 ：
台北市大安區信義路四段 6 號 16 樓之 12
大安捷運站共構大樓，四號出口
線上直播平台：
Zoom
線上直播連結將於開課前七日內，透過學員報名時提供之電子郵件寄送。學員應自行確認電子郵件地址正確，並留意收信狀況。建議避免使用 Yahoo 或 Hotmail 信箱，以免漏收課程通知。
若因學員提供之聯絡資訊錯誤、信箱設定、垃圾郵件過濾、未即時查收訊息或其他可歸責於學員之因素，導致未收到課程通知、直播連結或其他課程資訊，本公司不負延誤通知之責任。

四、課程名額與報名
本課程現場面授限額 14 名，按照完成報名與付款之順序保留名額。線上直播原則上無參與人數限制，惟本公司仍保留視課程品質、系統容量或其他課程營運需求調整報名名額之權利。
若現場面授名額額滿，報名者得選擇改報線上直播，或依本公司公告方式登記候補。若有名額釋出，本公司將依候補順序通知是否候補成功。
本課程截止報名時間為開課前三日，或額滿即提前截止報名。
未依本公司指定方式完成付款者，本公司不保留課程名額。

五、課程費用
本課程費用依課程網站及本公司公告價格為準。實際付款金額、付款方式及發票或收據開立方式，依本公司報名頁面、付款通知或客服人員說明為準。
本公司得依行銷活動提供早鳥優惠、團報優惠、企業／團隊優惠或其他促銷價格，優惠條件依活動公告為準。不同優惠不得合併使用，除非本公司另有明確公告。
課程費用須於報名後依指定方式完成一次性付款。未完成付款者，本公司不保留課程名額。

六、課程異動、延期或取消
本公司保留接受本訂單及開課與否之權利。
若因報名狀況、講師因素、場地因素、系統因素、天災、疫情、政府命令、不可抗力或其他非可歸責於本公司之因素，導致課程無法如期舉辦，本公司得視情況調整課程日期、授課形式、授課地點、授課平台或取消課程。
如課程延期、改期、改為線上直播或取消，本公司將以電子郵件、LINE 官方帳號或其他適當方式通知學員。
若本公司取消課程，學員得選擇：
● 全額退費；
● 保留名額參與後續課程場次。
若本公司僅調整課程形式、日期、地點或平台，相關退費或保留名額方式，將依本公司通知內容及實際異動情形辦理。

七、退款、取消或變更課程規定（報名前請詳閱）
若學員因個人因素需取消、變更、轉讓名額或申請退費，應依下列規定辦理：
1. 開課前 7 日以上
學員如於開課前 7 日以上，以書面方式通知本公司，包括發送電子郵件至 service@beckertw.com，或發訊通知 Becker Taiwan LINE 官方帳號，得免費辦理退款或取消課程。
2. 開課前 3 日至 7 日
學員如於開課前 3 日至 7 日期間，以書面方式通知本公司取消或變更課程者，得選擇下列方式之一辦理：
● 退還已繳課程費用 40%；或
● 另行支付 30% 原課程費用作為課程異動費用，並得於本公司日後開設之同類型課程中擇期補課一次。
3. 開課前 3 日內
學員如於開課前 3 日內提出取消或變更申請者：
● 不得申請退費；
● 得將課程名額轉讓予他人一次，惟須事先通知本公司並完成學員資料變更；或
● 另行支付 10% 原課程費用作為課程異動費用，並得於本公司日後開設之同類型課程中擇期補課一次。
4. 課程當日未到課
若學員於課程當日未到課，視為已使用課程服務，恕不接受退費申請，亦不當然享有補課、改期或觀看錄影回放之權利。
5. 補課期限與限制
補課須於原課程開課日起一年內完成，逾期視同放棄補課權利。
補課須依本公司後續課程名額、課程形式及實際開課狀況安排，本公司不保證特定場次、特定形式或特定講師之名額。
6. 開課日之定義
本契約所稱「開課日」，係指本課程實際開始上課之日期，即 2026 年 8 月 22 日（星期六）。若本公司另行公告改期，則以改期後之實際課程開始日期為準。

八、名額轉讓
學員如無法參加課程，得依本契約第七條規定，於課程開始前通知本公司，並將課程名額轉讓予他人一次。
受讓人應提供本公司辦理報名資料變更所需之姓名、電子郵件、聯絡電話及其他必要資料。
名額轉讓完成後，原學員不得再主張使用該課程名額、申請退費或再行轉讓。
若轉讓涉及現場面授或線上直播形式變更，須經本公司確認是否尚有可用名額或技術條件。

九、報到方式
1. 現場面授報到
現場面授學員應於課程開始前完成報到，並請備妥有效身份證件，例如身份證、駕照或健保卡擇一，以供本公司核對學員身份。
如學員未能提供必要身份確認資訊，本公司得要求學員補充資料或暫緩入場。
2. 線上直播報到
線上直播學員應於授課當日 8:45 至 9:00，至 Becker Taiwan 官方 LINE 帳號傳送身份確認，以完成線上報到並進入直播室。
學員應自行確認網路連線、裝置、音訊、瀏覽器或 Zoom 軟體可正常使用。若因學員端設備、網路環境、操作問題或其他可歸責於學員之因素，導致無法順利參與課程，本公司不負補課或退費責任。

十、智慧財產權與課程內容使用限制
本課程所有教材、講義、投影片、課程錄影、課程錄音、案例資料及相關內容之智慧財產權，均屬捷進顧問有限公司、授課講師或合法權利人所有。
學員僅得為個人學習目的使用，不得為任何商業、公開、轉售、散布或再製目的使用。
課程期間及課後，學員不得：
● 自行錄音
● 自行錄影
● 拍照
● 側錄螢幕畫面
● 語音轉錄
● 逐字紀錄（scribe）
● 翻印教材
● 複製課程內容
● 轉載或引用未經授權之課程資料
● 上傳至網路、社群平台、雲端空間或任何公開／非公開共享平台
● 散布、販售、交換、出借或提供予第三人使用
如有侵害智慧財產權、違反課程內容使用限制或其他不當使用行為，本公司將依法追究相關民刑事責任，並得停止該學員參與課程或使用課程相關資源之權利，且不予退費。

十一、課程秩序
學員於課程期間應遵守教學秩序、場地規範、線上會議規範及本公司相關指示。
學員不得有下列行為：
● 干擾講師授課或其他學員學習
● 以不當言行騷擾講師、本公司人員或其他學員
● 未經允許於課堂中推銷商品或服務
● 分享未經核准之連結、廣告或招攬訊息
● 以他人身份報到或參與課程
● 將線上直播連結提供予未報名者使用
● 其他足以影響課程進行或違反本契約之行為
若學員行為嚴重影響課程進行，本公司得要求其離場、移出線上會議室或停止其參與課程之權利，且不予退費。

十二、隱私權聲明
本公司依個人資料保護法蒐集學員於報名、付款、報到、客服聯繫及課程服務過程中提供之資料，包括但不限於：
● 姓名
● 電子郵件
● 聯絡電話
● LINE 帳號或其他聯絡資訊
● 付款資訊
● 發票或收據開立資訊
● 報名課程與參與紀錄
● 客服往來紀錄
使用目的包括：
● 課程報名管理
● 付款與帳務處理
● 身份確認與報到管理
● 課程通知
● 客戶服務
● 課後資源或優惠通知
● 行銷資訊通知
● 法令遵循或爭議處理
本公司將於服務存續期間、業務所需期間或法律規定之保存期限內利用該資料。
如學員需行使個資相關權利，得來信 service@beckertw.com 與本公司聯繫。

十三、免責聲明
本課程內容僅供學習與專業能力提升之用，不構成法律、稅務、投資或其他專業建議。
美國稅務申報與補報涉及個人身份、居住地、收入來源、資產類型、帳戶狀況、申報歷史、婚姻與家庭狀態、持股架構及其他具體事實。學員不得僅依本課程內容自行判斷個案申報義務、補報方式、揭露責任、稅負結果或罰則風險。
如有個別資產規劃、稅務申報、補報、海外資產揭露或風險判斷需求，應洽詢合格律師、會計師、EA、稅務律師或其他專業顧問。
本公司及授課講師不保證學員完成本課程後，即可自行完成美國稅務申報、補報、揭露程序或處理任何個案稅務問題，亦不保證學員因參與本課程而取得特定稅務、法律、財務或商業結果。

十四、購買資格
購買本課程者應為：
● 具有完全行為能力之人；
● 已取得法定代理人同意之限制行為能力人。
若購買者代表公司、團體或第三人報名，購買者應確認其有權代表該公司、團體或第三人完成報名、付款並同意本契約條款。

十五、管轄法院
因本契約所生之一切爭議，雙方同意以臺灣臺北地方法院為第一審管轄法院，但不得排除消費者保護法或民事訴訟法有關小額訴訟管轄法院之適用。

捷進顧問有限公司
Direct Line Consulting Co.
電話：02-2700-0053
客服信箱：service@beckertw.com
地址：台北市大安區信義路四段 6 號 16 樓之 12
統一編號：80523352`;

  const renderLine = (line, index) => {
  const text = line.trim();

  if (!text) {
    return <div key={index} className="mb-3"></div>;
  }

  if (
    index === 0 ||
    text === "（購買契約書）"
  ) {
    return (
      <div key={index} className="text-center mb-2">
        {text}
      </div>
    );
  }

  if (/^[一二三四五六七八九十]+、/.test(text)) {
    return (
      <div key={index}>
        <div className="br mb-5 mt-3"></div>
        <div className="h4">{text}</div>
      </div>
    );
  }

  if (/^\d+\./.test(text) || /^（[一二三四五六七八九十]+）/.test(text)) {
    return <div key={index} className="h5 mt-4 mb-4">{text}</div>;
  }

  if (text.startsWith("●")) {
    return (
      <p key={index} className="mb-2" style={{ paddingLeft: "1.5rem" }}>
        {text}
      </p>
    );
  }

  return <p key={index} className="mb-2">{text}</p>;
};
  return (
    <div className="container mb100 mt100">
      <div className="beckertitlename mb100 mt100">
        美國稅務風險自檢課
      </div>

      <div className="card w-75 p-5 m-auto">
        <h5 className="card-title text-black text-center">
          美國稅務風險自檢課：美籍身份、海外收入與補報入門
        </h5>

        <div className="br mb-5 mt-3"></div>

        <div className="card-body">
          <div className="card-text m-auto">
            {contractText.split("\n").map(renderLine)}
          </div>

          <div className="text-center">
            <label>
              <input
                className="m-2"
                type="checkbox"
                value="read"
                checked={isChecked}
                onChange={handleCheckboxChange}
                required
              />
              <span>我已詳閱並且了解</span>
            </label>

            <div
              className="btn btn-primary m-3"
              onClick={handleNextButtonClick}
            >
              下一步
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
